import React from 'react';

function PageTitle() {
    return (
        <div className='page-title text-center'>
            <div>
                Do you want a
                <span className='colored-text pl-2'>Website</span>
                ?
            </div>
        </div>
    );
}

export default PageTitle;